<script lang="ts" setup>
import CoreAppLogo from '#core/components/Core/CoreLogo.vue'

// We override the core CoreLogo and re-render it with the liquidity badge

defineOptions({
  inheritAttrs: false,
})
defineProps<{ dark?: boolean, collapsed?: boolean }>()
</script>

<template>
  <CoreAppLogo :dark="dark" :collapsed="collapsed" v-bind="$attrs" app-name="Liquidity" class="text-white" />
</template>
